import Vue from 'vue'

export const cursor = Vue.observable({ label: '', hidden: false })

export function setCursorLabel(label = '') {
  cursor.label = label
}

export function setCursorHidden(hidden) {
  cursor.hidden = hidden
}
